import { useQuery } from "@tanstack/react-query";
import { ChatKeys } from "web_myplann/Api/Chat/ChatKeys";
import type { ChatConversation } from "web_myplann/Chat/Types/chatConversation";
import { postChatList } from "web_myplann/Infrastructure/ApiOld/Api";

export const useChatListQuery = () =>
	useQuery({
		queryKey: ChatKeys.list(),
		queryFn: () => postChatList(),
		select: (response): ChatConversation[] => response.data?.data.items ?? [],
	});
